import React from 'react'
import { Result, Button } from 'antd'

function Success({ data, onCancel }) {
  return (
    <Result
      status="success"
      title="Successfully Payment Has been Possessed"
      subTitle="Thanks you"
      extra={[
        <Button onClick={onCancel} type="primary" key="console">
          Go Back
        </Button>,
      ]}
    />
  )
}

export default Success
